module.exports = __webpack_public_path__ + "static/img/iphone_ldtpage6.b5809a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldtpage6.png
// module id = dble
// module chunks = 0